<template>
  <div>
    <div class="tabs">
      <div :class="'tab-item '+(actived==='getWordSub'?'tab-item-active':'')" @click="changeTab('getWordSub')">技术文档</div>
      <div :class="'tab-item '+(actived==='getVideoSub'?'tab-item-active':'')"  @click="changeTab('getVideoSub')">技术视频</div>
    </div>
    <!-- 技术文档 -->
    <div class="tab-item-content">
      <div class="edit-but">
        <div :class="'edit-but-text '+(butLoading?'but-loading':'')" @click="editHandle()" v-if="!(treeList.length===0&&editFlag===false)">
          <i class="el-icon-loading" v-if="butLoading"></i>
          {{editFlag?'完成':'编辑'}}
        </div>
      </div>
      <div class="category" v-for="(item, index) in treeList" :key="item.id">
        <div class="category-first">
          <div class="category-item">
            <div v-if="editFlag&&item.isSubscription" class="category-item-delete" @click="candelSubscribeHandle([index])"><span>X</span></div>
            {{item.fileTypeName||item.videoTypeName}}
          </div>
        </div>
        <div class="category-two">
          <div class="category-item" v-for="(chil, idx) in item.children" :key="chil.id">
            <div v-if="editFlag&&chil.isSubscription" class="category-item-delete" @click="candelSubscribeHandle([index,idx])"><span>X</span></div>
            {{chil.fileTypeName||chil.videoTypeName}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      BASE_URL: process.env.BASE_URL,
      actived: 'getWordSub',
      editFlag: false,
      treeList: [],
      butLoading: false
    }
  },
  mounted () {
    this.editFlag = false
    this[this.actived]()
  },
  methods: {
    // 切换tab
    changeTab (key) {
      if (this.actived !== key) {
        this.actived = key
        this.editFlag = false
        this[key]()
      }
    },
    // 获取文档订阅数据
    getWordSub () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicaldoc/technicalfiletype/searchFileType`, {
        userId: this.$store.state.user.id || null
      })
        .then(({ data }) => {
          let treeList = []
          if (data && data && data.code === 0) {
            let sourlist = data.data || []
            if (sourlist.length) {
              sourlist.forEach(item => {
                if (item.isSubscription) {
                  treeList.push(item)
                } else if (item.children && item.children.length) {
                  let children = item.children.filter(it => {
                    return it.isSubscription
                  })
                  if (children.length) {
                    item.children = children
                    treeList.push(item)
                  }
                }
              })
            }
          }
          this.treeList = treeList
        })
        .catch(() => {
          this.treeList = []
        })
    },
    // 获取视频订阅数据
    getVideoSub () {
      this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/technicalvideo/technicalvideotype/searchVideoType`, {
        userId: this.$store.state.user.id || null
      })
        .then(({ data }) => {
          let treeList = []
          if (data && data.code === 0) {
            let sourlist = data.data || []
            if (sourlist.length) {
              sourlist.forEach(item => {
                if (item.isSubscription) {
                  treeList.push(item)
                } else if (item.children && item.children.length) {
                  let children = item.children.filter(it => {
                    return it.isSubscription
                  })
                  if (children.length) {
                    item.children = children
                    treeList.push(item)
                  }
                }
              })
            }
          }
          this.treeList = treeList
        })
        .catch(() => {
          this.treeList = []
        })
    },
    // 编辑
    editHandle (key) {
      // this.editFlag = !this.editFlag
      if (this.butLoading) {
        return
      }
      if (this.editFlag) {
        this.butLoading = true
        // 完成
        let secondTypeIdSet = []
        this.treeList.forEach(item => {
          if (item.isSubscription) {
            secondTypeIdSet.push(item.id)
          }
          if (item.children && item.children.length) {
            item.children.forEach(it => {
              if (it.isSubscription) {
                secondTypeIdSet.push(it.id)
              }
            })
          }
        })
        this.$http.post(`${window.SITE_CONFIG['apiURL']}/front/kc/userInfo/usersubscribe/userSubscribe`, {
          'secondTypeIdSet': secondTypeIdSet,
          'subsribeType': this.actived === 'getWordSub' ? 'FILE' : 'VIDEO'
        })
          .then(({ data }) => {
            if (data.code === 0) {
              this.$message.success('修改成功')
              this[this.actived]()
              this.editFlag = false
            } else {
            }
            this.butLoading = false
          })
          .catch(() => {
            // console.log(err, 'err')
            // this.$message.error(err.response.data.message)
            this.butLoading = false
          })
      } else {
        this.editFlag = true
      }
    },
    // 取消订阅
    candelSubscribeHandle (arr) {
      if (arr.length === 1) {
        this.treeList.splice(arr[0], 1)
      } else if (arr.length === 2) {
        if (this.treeList[arr[0]].children.length === 1) {
          this.treeList.splice(arr[0], 1)
        } else {
          this.treeList[arr[0]].isSubscription = false
          this.treeList[arr[0]].children.splice(arr[1], 1)
        }
      }
    }
  }
}
</script>
<style scoped>
.edit-but{
  position: relative;
  right: 69px;
  height: 40px;
}
.edit-but-text{
  cursor: pointer;
  position: absolute;
  right: 0;
  width: 112px;
  background-color: #1D65A8;
  height: 40px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  color: #FFFFFF;
}
.but-loading{
  opacity: 0.5;
  cursor: not-allowed;
}
.category{
  /* padding-bottom: 100px; */
  /* line-height: 40px; */
  padding-left: 69px;
  padding-right: 69px;
  border-bottom: 2px solid #eee;
}
.category-first{
  margin-top: 30px;
  padding-bottom: 9px;
  border-bottom: 1px solid #eee;
  width: 700px;
}
.category-item{
  display: inline-block;
  text-align: center;
  border: 1px solid #1D65A8;
  min-width: 108px;
  height: 42px;
  padding: 0 10px;
  line-height: 40px;
  font-size: 14px;
  color: #1D65A8;
  letter-spacing: 0.2px;
  margin-bottom: 30px;
  position: relative;
  margin-right: 40px;
}
.category-item-delete{
  cursor: pointer;
  position: absolute;
  right: 0;
  width: 17px;
  height: 17px;
  background:#C01920;
  border-radius: 0px 0px 0px 100px;
  color: #fff;
  /* text-align:right; */
}
.category-item-delete span{
  position: relative;
  top: -13px;
  right: -3px;
}
.category-two{
  padding-top: 19px;
  padding-bottom: 6px;
}
.category-item-mar{
  margin-right: 41px;
}
.tab-item-active {
  color: #1D65A8;
  border-bottom: 2px solid #1D65A8;
}
.tab-item {
  display: inline-block;
  /* padding: 12px 16px; */
  text-align: center;
  background: #FFFFFF;
  /* box-shadow: inset 0 -1px 0 0 #dddddd; */
  /* width: 88px; */
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  letter-spacing: 0;
  margin-right: 24px;
  cursor: pointer;
}
</style>
